import {getDefaultState} from '@/store/modules/spec/state'

export const RESET_STATE = 'RESET_STATE'


export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}
